(function(){
  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('de') !== 0) return;

  function reorder(el){
    if (el.hasAttribute('data-de-reordered')) return;
    var cfg = el.getAttribute('wallet-configs');
    if (!cfg) return;
    try {
      var arr = JSON.parse(cfg);
      var idx = arr.findIndex(function(w){ return w && w.name === 'paypal'; });
      if (idx <= 0){ el.setAttribute('data-de-reordered','1'); return; }
      var pp = arr.splice(idx, 1)[0];
      arr.unshift(pp);
      var clone = el.cloneNode(false);
      [].slice.call(el.attributes).forEach(function(a){
        if (a.name !== 'wallet-configs') clone.setAttribute(a.name, a.value);
      });
      clone.setAttribute('wallet-configs', JSON.stringify(arr));
      clone.setAttribute('data-de-reordered','1');
      el.parentNode.replaceChild(clone, el);
    } catch(e){ console.warn('DE PayPal reorder failed', e); }
  }

  function scan(){
    document.querySelectorAll('shopify-accelerated-checkout-cart:not([data-de-reordered])').forEach(reorder);
  }

  scan();
  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();